import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
// import NextImage from '@/components/NextImage';

export default function G() {
    const { useEffect, useState, useLang, useRouter } = useGlobal();
    const { t } = useLang('corporatesocialresponsibility');
    const { locale } = useRouter();
    const linksArr: any = [
        {
            name: t('secG_na'),
            link: 'media.na@ecoflow.com',
        },
        {
            name: t('secG_eu'),
            link: 'media.eu@ecoflow.com',
        },
        {
            name: t('secG_jp'),
            link: 'media.jp@ecoflow.com',
        },
        {
            name: t('secG_ap'),
            link: 'media.apac@ecoflow.com',
        },
        {
            name: t('secG_lamea'),
            link: 'media.lamea@ecoflow.com',
        },
    ];

    return (
        <div className={`csr-G ${css['csr-G']}`}>
            <div className="secG">
                <div className="text-box">
                    <p className="title">{t('secG_title')}</p>
                    <p className="desc">{t('secG_desc')}</p>
                </div>
                <ul className="link-box">
                    {linksArr?.map((link: any, k: number) => (
                        <li className="link-item" key={link?.name + '_' + k}>
                            <span className="link-text">{link.name}</span>
                            <a className="link-href" href={`mailto:${link?.link}`}>
                                {link?.link}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
